import React from 'react';
import { motion } from 'framer-motion';

/**
 * Compact horizontal "row card" for dense list UIs.
 * columns: [{ key, label, className, render(item) }]
 */
function DataRow({ item, index = 0, leading, title, subtitle, meta, badges, actions, onClick, className = '' }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2, delay: Math.min(index * 0.02, 0.2) }}
      className={`ux-data-row ${onClick ? 'ux-data-row-clickable' : ''} ${className}`.trim()}
    >
      <Tag type={onClick ? 'button' : undefined} className="ux-data-row-inner" onClick={onClick}>
        {leading && <div className="ux-data-row-leading">{leading}</div>}
        <div className="ux-data-row-body">
          <div className="ux-data-row-title">{title}</div>
          {subtitle && <div className="ux-data-row-sub">{subtitle}</div>}
          {meta && <div className="ux-data-row-meta">{meta}</div>}
        </div>
        {badges && <div className="ux-data-row-badges">{badges}</div>}
        {actions && <div className="ux-data-row-actions">{actions}</div>}
      </Tag>
    </motion.div>
  );
}

export function DataRowList({ children, className = '' }) {
  return <div className={`ux-data-row-list ${className}`.trim()}>{children}</div>;
}

export default DataRow;
